import { Box, TextInput, Text, Meter, Stack, Header, DataTable, Pagination } from "grommet";

import HomePageNav from "../components/Base components/HomePageNav";
// import SheetHeader from "../components/Base components/SheetHeader";
import QueriesForm from "../components/Queries/QueriesForm";
import EvaluetionsByStationsReport from "../components/Queries/EvaluetionsByStationsReport";

const QueriesPage = () =>{
    // return <QueriesForm/>;
    //return <EvaluetionsByStationsReport/>;
    
    
    return(
        <Box
            maxWidth="100%"
            justify="between"       
        >
            <Box 
                style={{ 
                    position: 'fixed',
                    width: '100px',
                    top: 0,
                    zIndex: 10,
                }}>

                <Box margin={{ vertical: "xxsmall" }}>
                    <HomePageNav />
                </Box>  
            </Box>   
            <EvaluetionsByStationsReport/>
        </Box>   
    );
};

export default QueriesPage;